import React, { Component, ReactNode } from 'react';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
}

class TableRowErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  public static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  public componentDidCatch(error: Error) {
    console.warn('TableRowErrorBoundary caught an error:', error);
  }

  public render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }
      
      return (
        <tr>
          <td colSpan={100} style={{ 
            padding: '8px 16px', 
            color: '#68737d', 
            fontStyle: 'italic',
            textAlign: 'center' 
          }}>
            Error rendering row data
          </td>
        </tr>
      );
    }

    return this.props.children;
  }
}

export default TableRowErrorBoundary;
